import { baseUrl } from '../../baseurl';
import { create } from 'zustand';
import axios from 'axios';

export const useLocations = create((set, get) => ({
  countries: [],
  provinses: [],
  cities: [],
  areas: [],
  neighbourhood: [-1],
  showServerError: false,
  resFromValidatCode: {},
  loadingAreas: false,
  locationName: '',
  districtsLoader: false,
  actions: {
    getAllCountries: () => {
      axios.get(`${baseUrl}/CityState/GetLocationByMasterId?masterId=1`)
        .then(res => {
          set({ countries: res.data });
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getAllProvinses: (id) => {
      axios.get(`${baseUrl}/CityState/GetLocationByParentId?parentId=${!id ? 1 : id}`)
        .then(res => {
          set({ provinses: res.data });
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getAllAreas: (id) => {
      set({ loadingAreas: true })
      axios.get(`${baseUrl}/CityState/GetLocationByParentId?parentId=${id}`)
        .then(res => {
          // set({ areas: res.data });
          set({ areas: res.data, loadingAreas: false });
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getAllCities: (id) => {
      axios.get(`${baseUrl}/CityState/GetLocationByParentId?parentId=${!id ? 3 : id}`)
        .then(res => {
          set({ cities: res.data });
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getAllNeighbourhood: (id) => {
      set((state) => ({ districtsLoader: true }))
      axios.get(`${baseUrl}/CityState/GetLocationByParentId?parentId=${!id ? 3 : id}`)
        .then(res => {
          set({ neighbourhood: res.data });
          set((state) => ({ districtsLoader: false }))
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getLocationName: (id) => {
      axios.get(`${baseUrl}/CityState/GetLocationById?Id=${!id ? 3 : id}`)
        .then(res => {
          set({ locationName: res.data });
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    validateReferCode: async (referCode) => {
      await axios.post(`${baseUrl}/User/AddReferralUserCode`, {
        "code": referCode,
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
        }
      })
        .then((res) => {

          set({ resFromValidatCode: res.data });
        }).catch(() => {

        })
    },


  },
}));

// In your component

